export type Language = typeof AVAILABLE_LANGUAGES[keyof typeof AVAILABLE_LANGUAGES]['id'];

export const AVAILABLE_LANGUAGES = {
    EN: {
        id: 'en',
        flagId: 'gb',
        name: 'English'
    },
    DE: {
        id: 'de',
        flagId: 'de',
        name: 'Deutch'
    },
    RU: {
        id: 'ru',
        flagId: 'ru',
        name: 'Русский'
    },
    LV: {
        id: 'lv',
        flagId: 'lv',
        name: 'Latviski'
    },
    LT: {
        id: 'lt',
        flagId: 'lt',
        name: 'Lietuviška'
    },
    EE: {
        id: 'ee',
        flagId: 'ee',
        name: 'Eesti'
    },
    PL: {
        id: 'pl',
        flagId: 'pl',
        name: 'Polski'
    },
    FR: {
        id: 'fr',
        flagId: 'fr',
        name: 'Français'
    },
    ES: {
        id: 'es',
        flagId: 'es',
        name: 'Español'
    },
    IT: {
        id: 'it',
        flagId: 'it',
        name: 'Italiano'
    },
    BG: {
        id: 'bg',
        flagId: 'bg',
        name: 'Български'
    },
    CZ: {
        id: 'cz',
        flagId: 'cz',
        name: 'Česky'
    },
    NL: {
        id: 'nl',
        flagId: 'nl',
        name: 'Nederland'
    }
} as const;
